import React from 'react'
import LinkComponent from '@components/LinkComponent'
import Image from 'next/image'
import { FaLine, FaTiktok, FaWhatsappSquare, FaPhoneSquareAlt, FaYoutube, FaLinkedin } from 'react-icons/fa'
import { AiFillInstagram, AiFillFacebook, /*AiFillTwitterSquare,*/ AiFillWechat } from 'react-icons/ai'

const AgentDisplayCard = ({ agent, imageWidth = 300, imageHeight = 500, button = true }) => {
  return (
    <div className={`relative sm:w-[${imageWidth}px] w-full md:mb-0 mb-2`}>
            <LinkComponent
                href={'/agents/' + agent.slug}
            >
                <div>
                    <div className='relative overflow-hidden sm:w-[300px] w-full aspect-[3/4] rounded-md'>
                        <Image
                            // placeholder="blur"
                            // blurDataURL={property.blur}
                            // className=''
                            src={agent.cover ? agent.cover : '/images/defaultagent.jpg'}
                            className='object-cover'
                            fill={true}

                            // width={imageWidth}
                            // height={imageHeight}
                            alt={agent.slug}
                        />
                    </div>
                    <div className='w-full justify-center items-center flex flex-col py-1'>
                        <p className='text-maincolor font-semibold'>{agent.agentName}</p>
                        <p className='text-secondary'>{agent.position}</p>
                    </div>
                    {button && (
                        <div className='w-full bg-third text-light rounded-md py-1 my-1'>
                            <LinkComponent className='flex justify-center items-center' href={'/agents/' + agent.slug}><span>See All Listings</span></LinkComponent>
                        </div>
                    )}
                </div>
            </LinkComponent>
    </div>
  )
}

export default AgentDisplayCard